<pds-module-header title="Configurações" ctaLabel="Voltar" [ctaOnClick]="navigateBack.bind(this)">
  <pds-new-breadcrumb [items]="breadcrumbItems" />
  <main class="anymarket-page__content">
    <pds-panel>
      <form class="anymarket-page__form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <pds-form-section title="Publicador">
          <pds-form-row grid="1-1">
            <div class="anymarket-settings__filter-group">
              <label class="anymarket-settings__filter-label">Marca</label>

              <div class="anymarket-settings__toggle-group" role="group" aria-label="Modo de filtro de Marca">
                <button
                  type="button"
                  class="anymarket-settings__toggle-btn"
                  [class.--active]="isBrandBlacklist"
                  (click)="onBrandModeChange(true)"
                >
                  Exclusão
                </button>
                <button
                  type="button"
                  class="anymarket-settings__toggle-btn"
                  [class.--active]="!isBrandBlacklist"
                  (click)="onBrandModeChange(false)"
                >
                  Inclusão
                </button>
              </div>

              <pds-multi-select-autocomplete
                formControlName="brand"
                [source]="brandSource"
                placeholder="Pesquisar marcas"
                (autocomplete)="onBrandAutocomplete($event)"
              />

              @if (isBrandBlacklist && brandCount === 0) {
                <div class="anymarket-settings__filter-alert">
                  <pds-alert type="info" title="Atenção" icon="info">
                    Se <strong>Exclusão</strong> estiver selecionada e nenhuma marca for informada, vai retornar tudo.
                  </pds-alert>
                </div>
              } @else if (!isBrandBlacklist && brandCount === 0) {
                <div class="anymarket-settings__filter-alert">
                  <pds-alert type="error" title="Atenção" icon="warning">
                    Se <strong>Inclusão</strong> estiver selecionada e nenhuma marca for informada, não vai retornar nada (selecione ao menos uma para avançar).
                  </pds-alert>
                </div>
              }
            </div>

            <div class="anymarket-settings__filter-group">
              <label class="anymarket-settings__filter-label">Grupo de Produto</label>

              <div class="anymarket-settings__toggle-group" role="group" aria-label="Modo de filtro de Grupo de Produto">
                <button
                  type="button"
                  class="anymarket-settings__toggle-btn"
                  [class.--active]="isProductGroupBlacklist"
                  (click)="onProductGroupModeChange(true)"
                >
                  Exclusão
                </button>
                <button
                  type="button"
                  class="anymarket-settings__toggle-btn"
                  [class.--active]="!isProductGroupBlacklist"
                  (click)="onProductGroupModeChange(false)"
                >
                  Inclusão
                </button>
              </div>

              <pds-multi-select-autocomplete
                formControlName="productGroup"
                [source]="productGroupSource"
                placeholder="Pesquisar grupos"
                (autocomplete)="onProductGroupAutocomplete($event)"
              />

              @if (isProductGroupBlacklist && productGroupCount === 0) {
                <div class="anymarket-settings__filter-alert">
                  <pds-alert type="info" title="Atenção" icon="info">
                    Se <strong>Exclusão</strong> estiver selecionada e nenhum grupo for informado, vai retornar tudo.
                  </pds-alert>
                </div>
              } @else if (!isProductGroupBlacklist && productGroupCount === 0) {
                <div class="anymarket-settings__filter-alert">
                  <pds-alert type="error" title="Atenção" icon="warning">
                    Se <strong>Inclusão</strong> estiver selecionada e nenhum grupo for informado, não vai retornar nada (selecione ao menos um para avançar).
                  </pds-alert>
                </div>
              }
            </div>
          </pds-form-row>

          <pds-form-row grid="1-1">
            <div class="anymarket-settings__filter-group">
              <label class="anymarket-settings__filter-label">Vendedores</label>

              <div class="anymarket-settings__toggle-group" role="group" aria-label="Modo de filtro de Vendedores">
                <button
                  type="button"
                  class="anymarket-settings__toggle-btn"
                  [class.--active]="isBranchBlacklist"
                  (click)="onBranchModeChange(true)"
                >
                  Exclusão
                </button>
                <button
                  type="button"
                  class="anymarket-settings__toggle-btn"
                  [class.--active]="!isBranchBlacklist"
                  (click)="onBranchModeChange(false)"
                >
                  Inclusão
                </button>
              </div>

              <pds-multi-select-autocomplete
                formControlName="branchs"
                [source]="branchSource"
                placeholder="Pesquisar filiais"
                (autocomplete)="onBranchAutocomplete($event)"
              />

              @if (isBranchBlacklist && branchCount === 0) {
                <div class="anymarket-settings__filter-alert">
                  <pds-alert type="info" title="Atenção" icon="info">
                    Se <strong>Exclusão</strong> estiver selecionada e nenhum vendedor for informado, vai retornar tudo.
                  </pds-alert>
                </div>
              } @else if (!isBranchBlacklist && branchCount === 0) {
                <div class="anymarket-settings__filter-alert">
                  <pds-alert type="error" title="Atenção" icon="warning">
                    Se <strong>Inclusão</strong> estiver selecionada e nenhum vendedor for informado, não vai retornar nada (selecione ao menos um para avançar).
                  </pds-alert>
                </div>
              }
            </div>

            <pds-form-field label="Prazo de entrega (minutos)">
              <input type="number" min="0" placeholder="Ex: 120" formControlName="deliveryTime" />
            </pds-form-field>
          </pds-form-row>
        </pds-form-section>

        <hr />

        <pds-form-actions>
          <button pdsButton type="submit" [disabled]="!canSubmit">
            {{ isSubmitting ? 'Agendando...' : 'Agendar' }}
          </button>
        </pds-form-actions>
      </form>
    </pds-panel>
  </main>
</pds-module-header>